<template>
  <div class="flex flex-col items-center">
    <img
        src="../assets/locker.png"
        srcset="../assets/locker2x.png 2x"
        alt="locker_banner"
    />

    <div class="text-center">
      <h3 class="mt-[16px] text-[28px] font-[600] leading-[130%]">
        {{ t("PasskeyConfirmationModal | title") }}
      </h3>
      <div class="text-[16px] leading-[150%] mt-[16px] text-color-4">
        {{ t("PasskeyConfirmationModal | description") }}
      </div>
    </div>

    <div class="relative w-full mt-[58px]">
      <transition
          enter-from-class="opacity-0"
          enter-active-class="transition duration-300"
          leave-to-class="opacity-0"
          leave-active-class="transition duration-300"
      >
        <error-block v-if="serverError" :text="serverError" />
      </transition>
    </div>

    <base-button class="!w-full" @click="onResolve">
      {{ t('PasskeyConfirmationModal | authenticate') }}
    </base-button>

    <base-button
        type="shade"
        class="!w-full mt-[8px]"
        @click="onChangeConfirmationType"
    >
      {{ t("PasskeyConfirmationModal | passkeyDisabled") }}
    </base-button>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import { useI18n } from "vue-i18n";
import ErrorBlock from "../../../shared/ui/ErrorBlock/index.vue"
import PasskeyService from '@/packages/auth-service/services/passkey'
import {REQUIRED_USER_ACTIONS} from "../../../../common/const";
import AnalyticsService from "@emcd-shared/analytics-service";
import {ANALYTICS_EVENT_TYPE} from "../../../shared/utils/analytics";

const emit = defineEmits(["resolve", "reject", "close"]);
const props = defineProps({
  secretKey: {
    type: String,
    default: "",
  },
  passkeyData: {
    type: Object,
    required: true,
  },
  request: {
    type: Object,
    required: true,
  },
  axios: {
    type: Function,
    required: true,
  },
});

const { t } = useI18n();

const serverError = ref(null);

async function onResolve() {
  try {
    AnalyticsService.track(ANALYTICS_EVENT_TYPE.CLICK, {
      button_name: 'authenticate',
      screen: '2fa_passkey',
      subscreen: 'verify_passkey',
    })
    const result = await PasskeyService.Sign(props.passkeyData)

    const requestCopy = { ...props.request };
    requestCopy.headers["secret-value"] = result;
    requestCopy.headers["secret-key"] = props.secretKey;
    requestCopy.headers["2fa-method"] = REQUIRED_USER_ACTIONS.PASSKEY;

    const response = await props.axios(requestCopy);

    emit("resolve", response);
  } catch (e) {
    if (e.response?.data && e.response?.data.code) {
      serverError.value = t(e.response?.data.code)

      setTimeout(() => {
        serverError.value = null
      }, 3000)
    }
    console.error(e)
  }
}
function onChangeConfirmationType() {
  AnalyticsService.track(ANALYTICS_EVENT_TYPE.CLICK, {
    button_name: 'change_confirmation_type',
    screen: '2fa_passkey',
    subscreen: 'verify_passkey',
  })

  emit("reject", "CHANGE_TYPE");
}

onMounted(() => {
  AnalyticsService.track(ANALYTICS_EVENT_TYPE.POPUP, {
    event_subtype: '2fa_passkey_modal',
    screen: '2fa_passkey',
    subscreen: 'verify_passkey',
  })
})
</script>

<style scoped lang="scss">
.confirmation-passkey {
  &__container {
    max-width: 480px;
  }
}
</style>
